import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import {Circle as CircleStyle, Icon, Image, Text} from 'ol/style';
import '@mdi/font/css/materialdesignicons.css';
import { fill } from 'lodash';

export interface ChartColour {
    discriminator: string;
    borderColor: string;
    backgroundColor: string;
}

export class Styles {
    public static ThickTransparentLightBlue = new Style({
        stroke: new Stroke({
            color: "#33b9ff80",
            width: 8
        })
    })
    public static ThickTransparentLightGreen = new Style({
        stroke: new Stroke({
            color: "#33ffb980",
            width: 8
        })
    })
    public static LastAnchorDot = new Style({ 
        image: new CircleStyle({
            radius: 4.5,
            fill: new Fill({color: '#F44336'}),                 // red https://vuetifyjs.com/en/styles/colors/#material-colors
            stroke: new Stroke({color: '#1816b5', width: 2.7})  // blue outer
        })
    })
    public static MidAnchorDot = new Style({ 
        image: new CircleStyle({
            radius: 4.5,
            fill: new Fill({color: '#fff'}),                    // white filling
            stroke: new Stroke({color: '#1816b5', width: 2.7})  // blue outer
        })
    })
    public static Trackpoint = new Style({ 
        image: new CircleStyle({
            radius: 4,
            fill: new Fill({color: '#CFD8DC'}),               // blue-grey lighten 2
            stroke: new Stroke({color: '#37474F', width: 2})  // blue-grey darken-3
        })
    })
    public static TrackpointHighlighted = new Style({ 
        image: new CircleStyle({
            radius: 5,
            fill: new Fill({color: '#B3E5FC'}),               // light-blue lighten 3
            stroke: new Stroke({color: '#01579B', width: 2})  // light-blue darken 4
        })
    })
    public static FirstAnchorDot = new Style({ 
        image: new CircleStyle({
            radius: 4.5,
            fill: new Fill({color: '#64DD17'}),                 // light-green accent-4 : https://vuetifyjs.com/en/styles/colors/#material-colors
            stroke: new Stroke({color: '#1816b5', width: 2.7})  // blue outer
        })
    })

    public static ElevationChartHoverIndicator = new Style({ // Elevation chart hover indicator - on map, keep same colours as chart indicator (below)
        image: new CircleStyle({
            radius: 10,
            stroke: new Stroke({color: '#D50000', width: 3}), // red-accent-4
            fill: new Fill({color: '#FF525266'}) // red-accent-2, translucent
        })
    })
    public static elevChartHoverIndicatorFg = 'rgb(255, 99, 132)'       //Elevation chart hover indicator - on elev chart (foreground), keep same colours as map indicator (above)
    public static elevChartHoverIndicatorBg = 'rgba(255, 99, 132, 0.5)' //Elevation chart hover indicator - on elev chart (background), keep same colours as map indicator (above)

    public static DefaultTrackColour = "#0505a6" // DarkBlue
    public static DefaultRouteColour = "#a60505" // DarkReda

    public static CurrentLocationMarkerStyle = new Style({ 
        image: new CircleStyle({
            radius: 8,
            fill: new Fill({color: '#2962FF'}),                 // blue accent-4 : https://vuetifyjs.com/en/styles/colors/#material-colors
            stroke: new Stroke({color: '#82B1FF', width: 5})  // blue accent-1 outer, semi transparent
        })
    })


    static getColourForGradient(gradient: number): ChartColour {
        if(gradient < 0.04) {
            return {
                discriminator: 'green',
                backgroundColor: '#66BB6A', //green-lighten-1
                borderColor: '#43A047' //green-darken-1
            }
        } else if(gradient < 0.09) {
            return {
                discriminator: 'amber-light',
                backgroundColor: '#FFCA28', // amber lighten 1
                borderColor: '#FFB300' //amber-darken-1
            }
        } else if (gradient < 0.14) {
            return {
                discriminator: 'amber-dark',
                backgroundColor: '#FB8C00', //orange lighten 1
                borderColor: '#FB8C00' //orange darken 1
            }
        } else if (gradient < 0.20) {
            return {
                discriminator: 'red-light',
                backgroundColor: '#EF5350', // red-lighten-1
                borderColor: '#E53935' //red-darken-1
            }
        } else  {
            return {
                discriminator: 'red-dark',
                backgroundColor: '#AD1457', // pink-darken-3
                borderColor: '#880E4F' //pink-darken-4
            } 
        }
    }
}